<ng-container *ngIf="hospitals?.length; else noHospitals">
    <div *ngFor="let hospital of hospitals; let i = index">
        <div *ngFor="let ward of hospital.wards; let j = index">
            <h3>{{hospital.name}} - {{ward.name}}</h3>
            <app-procedure-code-selector [initialCodes]="ward.procedureCodes"
                (codesChanged)="onProcedureCodesChanged($event, hospital, j)"></app-procedure-code-selector>
        </div>
    </div>
</ng-container>

<ng-template #noHospitals>
    <p class="hint">No hospitals found. Create your hospitals in settings to setup automatic ward
        coding.</p>
</ng-template>